import { gql } from '@apollo/client'

export default gql`
  fragment InstructorComponent on Person {
    id
    description
    facebook
    image {
      url
    }
    instagram
    jobTitle
    location
    name
    twitter
  }
`
